var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { NativeModule } from "./NativeModule";
import { NativeInterface } from "./NativeInterface";
var VibratorNative = /** @class */ (function (_super) {
    __extends(VibratorNative, _super);
    function VibratorNative() {
        var _this = _super.call(this) || this;
        NativeInterface.instance.addModule(_this);
        return _this;
    }
    VibratorNative.prototype.getPrefix = function () {
        return 'vibrator_';
    };
    /**
     * Does the device has a physical vibrator
     * @returns {Promise<boolean>}
     */
    VibratorNative.prototype.available = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'available',
            params: {}
        }).then(function (r) {
            return r.status !== undefined ? r.status : false;
        });
    };
    /**
     * Create a shortcuts on the desktop of the device
     * @param {number} time time of the vibration in milliseconds
     * @returns {Promise<void>}
     */
    VibratorNative.prototype.vibrate = function (time) {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'vibrate',
            params: {
                time: time,
            }
        });
    };
    VibratorNative.prototype.cancel = function () {
        var self = this;
        return NativeInterface.instance.request({
            name: self.getPrefix() + 'cancel',
            params: {}
        });
    };
    VibratorNative.prototype.onEvent = function (event) {
    };
    return VibratorNative;
}(NativeModule));
export { VibratorNative };
//# sourceMappingURL=VibratorNative.js.map